import { CssBaseline, ThemeProvider, GlobalStyles } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { ClickTrackingProvider } from 'design-system';
import { UnsupportedOSProvider } from 'providers/UnsupportedOSProvider';
import { ReactNode } from 'react';
import { getURLTheme } from 'services/theming';
import GraphProvider from 'components/GraphProvider';
import { GlobalSubscriptionsProvider } from 'hooks/Subscriptions/useGlobalSubscriptions';
import { FeatureProvider } from 'hooks/useFeatures';
import { SnackbarProvider } from 'hooks/useSnackBar';
import { UserProvider } from 'hooks/useUser';
import { trackClick } from 'utils/trackClick';

interface ProvidersProps {
  children: ReactNode;
}

const globalStyles = (
  <GlobalStyles
    styles={(theme) => ({
      [theme.breakpoints.up('md')]: {
        body: {
          overflowY: 'scroll',
        },
        '*::-webkit-scrollbar': {
          width: '6px',
          height: '6px',
        },
        '*::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.2)',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.primary.light,
          borderRadius: '9999px',
        },
      },
    })}
  />
);

const Providers = ({ children }: ProvidersProps) => {
  const theme = getURLTheme();
  return (
    <ClickTrackingProvider onClick={trackClick}>
      <SnackbarProvider>
        <UserProvider>
          <GraphProvider>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                {globalStyles}
                <FeatureProvider>
                  <UnsupportedOSProvider>
                    <GlobalSubscriptionsProvider>{children}</GlobalSubscriptionsProvider>
                  </UnsupportedOSProvider>
                </FeatureProvider>
              </ThemeProvider>
            </StyledEngineProvider>
          </GraphProvider>
        </UserProvider>
      </SnackbarProvider>
    </ClickTrackingProvider>
  );
};

export default Providers;
